export interface PasswordRules {
  len: boolean;
  mix: boolean;
  num: boolean;
  sym: boolean;
}

const upper = /[A-ZА-Я]/;
const lower = /[a-zа-я]/;
const digit = /\d/;
const symbol = /[^A-Za-zА-Яа-я0-9]/;

export function checkRules(password: string): PasswordRules {
  return {
    len: password.length >= 8,
    mix: upper.test(password) && lower.test(password),
    num: digit.test(password),
    sym: symbol.test(password) || password.length >= 12,
  };
}

export function passwordScore(password: string): number {
  if (!password) return 0;
  const r = checkRules(password);
  return Number(r.len) + Number(r.mix) + Number(r.num) + Number(r.sym);
}
